/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Risk_Mod_DetrainingInputs */

const en_coach_risk_mod_detraining = /** @type {(inputs: Coach_Risk_Mod_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your fitness is declining, and your training ramp rate is elevated. Avoid jumping back in too aggressively — a moderate, progressive return to training is safer than a sudden spike.`)
};

const de_coach_risk_mod_detraining = /** @type {(inputs: Coach_Risk_Mod_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Fitness sinkt, und die Trainingsrampe ist erhöht. Steig nicht zu aggressiv wieder ein — lieber moderat und progressiv als mit einem plötzlichen Sprung.`)
};

/**
* | output |
* | --- |
* | "Your fitness is declining, and your training ramp rate is elevated. Avoid jumping back in too aggressively — a moderate, progressive return to training is sa..." |
*
* @param {Coach_Risk_Mod_DetrainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_risk_mod_detraining = /** @type {((inputs?: Coach_Risk_Mod_DetrainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Risk_Mod_DetrainingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_risk_mod_detraining(inputs)
	return de_coach_risk_mod_detraining(inputs)
});